// Updated ProductMedia.js with logic moved from ManageProduct
import React, { useState, useRef } from "react";
import { Box, Grid, IconButton, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import DeleteIcon from "../../globalStyles/icons/deleteIcon";
import CustomTypography from "../../globalStyles/fonts";
import { isMobile } from "../../globalStyles/mobile";
import { imageService } from "../../utils/services/imageService";

const ProductMedia = ({
  selectedImages,
  setSelectedImages,
  imageUrls,
  setImageUrls,
  coverImageIndex,
  setCoverImageIndex,
  imageUrl,
  setImageUrl,
  selectedProduct,
  setSelectedProduct,
}) => {
  const fileInputRef = useRef(null);
  const [editingImageIndex, setEditingImageIndex] = useState(null);

  const handleChooseImage = (index = null) => {
    setEditingImageIndex(index);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
      fileInputRef.current.click();
    }
  };

  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const file = files[0];
      try {
        const imageData = await imageService.upload(file);
        const imageUrlBlob = URL.createObjectURL(file);
        setSelectedImages((prevImages) => {
          const newImages = [...prevImages];
          if (editingImageIndex !== null) {
            newImages[editingImageIndex] = {
              image: imageData.key,
              feature_image: editingImageIndex === coverImageIndex,
            };
          } else {
            newImages.push({
              image: imageData.key,
              feature_image: false,
            });
          }
          setImageUrl(newImages);
          return newImages;
        });

        setImageUrls((prevUrls) => {
          const newUrls = [...prevUrls];
          if (editingImageIndex !== null) {
            newUrls[editingImageIndex] = imageUrlBlob;
          } else {
            newUrls.push(imageUrlBlob);
          }
          return newUrls;
        });
        setEditingImageIndex(null);
      } catch (error) {
        console.error("Image upload failed:", error);
      } finally {
        e.target.value = null;
      }
    }
  };

  const handleCheckCoverImage = (index) => {
    setCoverImageIndex(index === coverImageIndex ? -1 : index);
    setSelectedImages((prevImages) => {
      const updatedImages = [...prevImages];
      updatedImages.forEach((image, i) => {
        image.feature_image = i === index;
      });
      return updatedImages;
    });
  };

  const removeSelectedImage = (indexToRemove) => {
    setSelectedImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );

    setImageUrls((prevUrls) =>
      prevUrls.filter((_, index) => index !== indexToRemove)
    );

    if (selectedProduct?.images) {
      const updatedImages = [...selectedProduct.images];
      updatedImages.splice(indexToRemove, 1);
      setSelectedProduct((prevProduct) => ({
        ...prevProduct,
        images: updatedImages,
      }));
    }

    if (coverImageIndex === indexToRemove) {
      setCoverImageIndex(-1);
    } else if (coverImageIndex > indexToRemove) {
      setCoverImageIndex((prev) => prev - 1);
    }
  };

  return (
    <Grid item xs={12} sx={{ marginTop: isMobile() ? 5 : 2 }} sm={12}>
      <CustomTypography
        style={{ textAlign: "left", fontWeight: "500" }}
        fontSize={15}
      >
        Media
      </CustomTypography>
      <Box
        sx={{
          width: "100%",
          border: 1,
          borderColor: "var(--border-color)",
          borderRadius: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "150px",
          p: 2,
          backgroundColor: "var(--bg-paper)",
          marginTop: 1,
        }}
      >
        <input
          id="productImageInput"
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleImageChange}
        />

        {selectedImages.length > 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
                gap: 2,
                mt: 2,
                maxHeight: 250,
                overflowY: "auto",
                border: "1px solid var(--border-color)",
                borderRadius: 1,
                p: 2,
              }}
            >
              {selectedImages.map((image, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    p: 1,
                    border: 1,
                    borderRadius: 1,
                    maxWidth: { xs: "100%", sm: "auto" },
                  }}
                >
                  <img
                    src={imageUrls[index]}
                    alt={`Selected image ${index}`}
                    style={{ maxWidth: 100, maxHeight: 100 }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      alignItems: "center",
                    }}
                  >
                    <IconButton onClick={() => handleChooseImage(index)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <input
                      type="checkbox"
                      checked={index === coverImageIndex}
                      onChange={() => handleCheckCoverImage(index)}
                    />
                    <IconButton onClick={() => removeSelectedImage(index)}>
                      <DeleteIcon color="error" />
                    </IconButton>
                  </Box>
                </Box>
              ))}
            </Box>
            <IconButton onClick={() => handleChooseImage(null)}>
              <AddIcon />
            </IconButton>
          </Box>
        ) : (
          <Button
            sx={{
              minWidth: { xs: 150, sm: 200 },
              color: "#707070",
              textTransform: "none",
            }}
            color="primary"
            onClick={() => handleChooseImage(null)}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              <IconButton aria-label="upload" sx={{ mb: 1, p: 0 }}>
                <InsertPhotoIcon />
              </IconButton>
              <Typography variant="body2">Upload</Typography>
            </Box>
          </Button>
        )}
      </Box>
    </Grid>
  );
};

export default ProductMedia;
